


import React, { useEffect, useRef, useState } from 'react'

import './ProducerPlayer.scss';
import { PeopleService } from '../../services/people-service';
import { PTApiService } from '../../services/ptapi-service';
import { WebRTCsdkService } from '../../services/webrtcsdk-service';

// import { FormControlLabel } from '@mui/material';
import { Producer, ProducerType } from '../../models/producerClass';

import { ReactComponent as CameraSvg } from '../../assets/icons/icon-video-title.svg';
import { ReactComponent as DisplaySvg } from '../../assets/icons/icon-screenshare-title.svg';
import { ReactComponent as ExpandSvg } from '../../assets/icons/icon-expand.svg';
import { ReactComponent as MenuSvg } from '../../assets/icons/icon-three-dots.svg';
import InlineEdit from '../utils/InlineEdit';
import { Tooltip } from '@mui/material';
import { IOSSwitch } from '../Switches/Switches';
import ProducerPlayer from './ProducerPlayer';
import PeopleMenu from '../submenu-people/PeopleMenu';

import { container } from 'tsyringe';

interface ProducerCardProps {
  // using `interface` is also ok
  producer: Producer,
  name: string,
  isSelf: boolean,
  isSpotted: boolean,
  isLive: boolean,
  audioMute: boolean,
  callQuality: number,
  isMenuOpened?: boolean,
  onToggleLive?: any,
  onToggleSpotted?: any,
  // onToggleMenu?: any,
  // onToggleMuted?: any,
  onSetName?: any,
  id?: string,
  preview?: boolean,
  videoMute: boolean,
  initials: string,
  speaking: boolean,
  camera: string,
};

const ProducerCard = (props: ProducerCardProps) => {

  const thisRef = useRef(undefined);

  const [peopleService] = useState(container.resolve(PeopleService));
  const [ptApiService] = useState(container.resolve(PTApiService));
  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));

  const [people, setPeople] = useState(null);

  const [lastClosedTime, setLastClosedTime] = useState(0);

  const [state, setState] = useState(
    {
      id: props.producer.id,
      url: props.producer.url,
      streamIndex: props.producer.streamIndex,
      name: props.name,
      isSelf: props.isSelf,
      type: props.producer.type,
      toggleLive: props?.onToggleLive,
      toggleSpotted: props?.onToggleSpotted,
      // toggleMenu: props?.onToggleMenu,
      // toggleMute: props?.onToggleMuted,
      setName: props?.onSetName,
      isLive: props.isLive,
      isSpotted: props.isSpotted,
      isMenuOpened: props.isMenuOpened,
      isRenaming: false,
      isRemoving: false,
      callQuality: props.callQuality,
      preview: props.preview,
      audioMute: props.audioMute,
      videoMute: props.videoMute,
      initials: props.initials,
      speaking: props.speaking,
      camera: props.camera,
    });

  const [lastActionDate, setLastActionDate] = useState(0);

  const minTime = 800;

  const handleSetName = (name) => {
    setState({ ...state, name });
    if (state.setName) {
      state.setName(name);
    }
  }

  const [maxEditWidth, setMaxEditWidth] = useState(200)


  const handleToggleLive = () => {

    // avoid toggling too fast
    if (Date.now() - lastActionDate < minTime) {
      return;
    }
    setLastActionDate(Date.now());

    const isLive = !state.isLive;
    if (state.toggleLive) {
      state.toggleLive(isLive);
      // this.setState({isLive});
    }
  }

  const handleToggleMenu = () => {
    const now = Date.now();
    if (now - lastClosedTime > 500) {
      const isMenuOpened = !state.isMenuOpened;
      // if (state.toggleMenu) {
      //   state.toggleMenu(isMenuOpened)
      // }
      setState({ ...state, isMenuOpened });

      try {
        if (thisRef.current) {
          const thisDiv: HTMLElement = thisRef.current;
          const p1 = thisDiv.parentElement;
          const p2 = p1.parentElement;
          const p3 = p2.parentElement;
          const lis = p3.childNodes;
          console.log(lis);
          for (let index in lis) {
            if (lis.hasOwnProperty(index)) {
              const li = lis[index] as HTMLElement;
              li.style.zIndex = '1';
            }
          }
          p2.style.zIndex = '10';
        }
      } catch(e) {
        console.log(e);
      }
    }

    setLastClosedTime(Date.now());
  }

  const handleToggleSpotted = () => {
    const isLive = state.isLive;
    const isSpotted = !state.isSpotted; // inverse old state
    if (isLive && state.toggleSpotted) {
      state.toggleSpotted(isSpotted);
    }
  }

  const handleToggleMute = () => {
    const audioMute = !people.audioMute;

    setState({ ...state, audioMute });

    // mute a remote participant
    // ptApiService.setParticipantMute(people.endpointGUID, 'audio', audioMute, false);
    peopleService.setParticipantMute(people.endpointGUID, 'audio', audioMute, false);

    if (people.isSelf) {
      // this is ourSelf
      webRTCsdkService.setAudioMuted(audioMute);
    }

  }
  const handleToggleVideoMute = () => {
    const videoMute = !people.videoMute;

    setState({ ...state, videoMute });

    // mute a remote participant
    // ptApiService.setParticipantMute(people.endpointGUID, 'audio', audioMute, false);
    peopleService.setParticipantMute(people.endpointGUID, 'video', videoMute, false);

    if (people.isSelf) {
      // this is ourSelf
      webRTCsdkService.setVideoMuted(videoMute);
    }

  }

  const handleClick = (e) => {
    if (e.detail === 2) {
      handleToggleLive();
    }
  }

  const handleClose = () => {
    setState({ ...state, isMenuOpened: false });
    setLastClosedTime(Date.now());
  }

  const handleRename = () => {
    setState({ ...state, isMenuOpened: false, isRenaming: true});
    setLastClosedTime(Date.now());
  }

  const handleRemove = () => {
    setState({ ...state, isMenuOpened: false, isRemoving: true});
    setLastClosedTime(Date.now());
  }

  useEffect(() => {
    setState({
      id: props.producer.id,
      url: props.producer.url,
      streamIndex: props.producer.streamIndex,
      name: props.name,
      isSelf: props.isSelf,
      type: props.producer.type,
      toggleLive: props?.onToggleLive,
      toggleSpotted: props?.onToggleSpotted,
      // toggleMenu: props?.onToggleMenu,
      // toggleMute: props?.onToggleMuted,
      setName: props?.onSetName,
      isLive: props.isLive,
      isSpotted: props.isSpotted,
      isMenuOpened: state.isMenuOpened,
      isRenaming: false,
      isRemoving: false,
      callQuality: props.callQuality,
      preview: props.preview,
      audioMute: props.audioMute,
      videoMute: props.videoMute,
      initials: props.initials,
      speaking: props.speaking,
      camera: props.camera,
    });

    // if (props.producer.url.length > 0) {
    //   console.log('PROD CARD isMenuOpened', props.name,  props.isMenuOpened);
    //   console.log('PROD CARD audioMute',    props.name,  props.audioMute);
    //   console.log('PROD CARD videoMute',    props.name,  props.videoMute);
    // }

    if (props.producer.participantGuid && props.producer.participantGuid.length > 0) {
      setPeople(peopleService.findPeople(props.producer.participantGuid));
    } else {
      setPeople(null);
    }

    // console.log('====', props.name, props.isLive, props.audioMute, props.speaking);
  }, [props])

  const setMaxWidth = () => {
    const innerWidth = window.innerWidth;
    if (innerWidth < 990) {
      setMaxEditWidth(props.isSelf ? 64 : 88);
    } else if (innerWidth >= 990 && innerWidth < 1366) {
      setMaxEditWidth(props.isSelf ? 84 : 107);
    } else {
      setMaxEditWidth(props.isSelf ? 104 : 140);
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setMaxWidth();
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div className={'player-container ' + (!state.preview ? 'player-container-with-padding' : 'player-container-no-padding') + (state.isLive ? ' live' : '') + (state.url.length == 0 ? ' empty' : '') + (state.speaking ? ' speaking' : '')} ref={thisRef}>

      {!state.preview &&
        <div className='player-controls'>

          {/* <Button  variant="contained" color="primary" disableElevation onClick={handlePlayPause}>{state.playing ? 'Pause' : 'Play'}</Button> */}

          {state.url.length > 0 &&
            <>
              { state.type !== ProducerType.CONTENT_SHARING &&
              <div className={'button ' + (state.isMenuOpened ? 'active' : 'idle')} id={'menu-' + state.id}>
                <MenuSvg className="menu" onClick={() => handleToggleMenu()} />
              </div>
              }
              <div className={'button ' + (state.isSpotted ? 'active' : 'idle')}>
                <ExpandSvg className="expand" onClick={() => handleToggleSpotted()} />
              </div>
              <Tooltip title={state.isLive ? "Turn Off-Air" : "Turn On-Air"} enterDelay={2000} placement='top-end'>
                <div className='switch keep-this-div-as-wrapper-for-switch-else-tooltip-wont-work'>
                  <IOSSwitch
                    width={40}
                    height={24}
                    checked={state.isLive}
                    onChange={() => handleToggleLive()}
                  />
                </div>
              </Tooltip>

              { /* state.isLive &&
                  <div className="onair">ON AIR</div>
                  */ }
            </>
          }
        </div>
      }

      <div onClick={handleClick}>
        <ProducerPlayer url={state.url} streamIndex={state.streamIndex} audioMute={state.audioMute} videoMute={state.videoMute} initials={state.initials} camera={state.camera}
        ></ProducerPlayer>
      </div>

      {!state.preview &&
        <div className="player-info">
          {state.url.length > 0 &&
            <>

              {state.type !== ProducerType.CONTENT_SHARING ?
                <div className={"camera " + (state.videoMute ? "camera-off" : "camera-on")} onClick={() => handleToggleVideoMute()}></div>
                :
                <DisplaySvg className="screenshare" />
              }
              <div className="name">
                <InlineEdit
                  height={15}
                  width={maxEditWidth}
                  key={state.name}
                  text={state.name}
                  focused={state.isRenaming}
                  placeHolder="&middot;&middot;&middot;"
                  onSetText={(text) => handleSetName(text)}
                />
                { state.isSelf &&
                  <div className="myself">(me)</div>
                }

              </div>
              {state.url.indexOf('webrtc-content-remote') == -1 && state.url.indexOf('showing-local-content') == -1 &&
                <>
                  <div className={"mic " + (state.audioMute ? "mic-off" : "mic-on")} onClick={() => handleToggleMute()}></div>
                  <div className={"network network-" + (1 * state.callQuality -1).toString()}></div>
                </>
              }
            </>
          }
        </div>
      }

      { people && state.isMenuOpened &&
        <PeopleMenu people={people} fromProducer={true} onClose={handleClose} onRename={handleRename} onRemove={handleRemove}></PeopleMenu>
      }


    </div>

  )

}

export default ProducerCard;